import React from 'react';

import clsx from 'clsx';

import { Icon } from '@atoms';

import classes from './navigation.module.scss';

type ArrowProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export const LeftArrow = ({ className, ...props }: ArrowProps) => {
  return (
    <div className={clsx(classes.arrowWrapper, className)} {...props}>
      <span className={classes.arrow}>
        <Icon icon="chevron-left" />
      </span>
    </div>
  );
};
export const RightArrow = ({ className, ...props }: ArrowProps) => {
  return (
    <div className={clsx(classes.arrowWrapper, className)} {...props}>
      <span className={classes.arrow}>
        <Icon icon="chevron-right" />
      </span>
    </div>
  );
};
